import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ICON_PATH_TOKEN } from '@shared/ui-shared';

export type iconRowType = 'frequency' | 'trash' | 'container' | 'bag';

@Component({
  selector: 'csl-icon-row',
  standalone: true,
  imports: [],
  templateUrl: './icon-row.component.html',
  styleUrl: './icon-row.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex gap-1 items-start',
    'data-testid': 'row-data',
  },
})
export class IconRowComponent {
  iconType$$ = input.required<iconRowType>();

  iconPath = inject(ICON_PATH_TOKEN);
}
